import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BellRing, LucideAngularModule } from "lucide-angular";

@Component({
  selector: 'app-notification-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss']
})
export class NotificationModalComponent {
  @Input() title!: string;
  @Input() body!: string;
  @Input() documentId?: string;

  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  BellRing = BellRing;
}
